import {
  fetchWrapper,
  handleResponse,
  hcUrl,
  buildOpts,
  formatBody,
} from 'services/RequestService/helpers';

export const createCustomerReport = async () => {
  const response = await fetchWrapper(
    hcUrl('/grace/customer_reports'),
    buildOpts({
      method: 'POST',
    })
  );
  return handleResponse(response);
};

export const findCustomerReport = async ({ params: { entranceStage } }) => {
  const response = await fetchWrapper(
    hcUrl(`/grace/customer_report${entranceStage ? '?entrance_stage=true' : ''}`),
    buildOpts({
      method: 'GET',
    })
  );
  return handleResponse(response);
};

export const createCustomerReportAction = async ({
  customerReportId,
  reportStageOptionId,
  incidentInfo,
}) => {
  const response = await fetchWrapper(
    hcUrl(`/grace/customer_reports/${customerReportId}/actions`),
    buildOpts({
      method: 'POST',
      body: formatBody({ reportStageOptionId, incidentInfo }),
    })
  );
  return handleResponse(response);
};

export const closeCustomerReport = async ({ customerReportId }) => {
  const response = await fetchWrapper(
    hcUrl(`/grace/customer_reports/${customerReportId}/`),
    buildOpts({
      method: 'DELETE',
    })
  );
  return handleResponse(response);
};

export const createSurveyRating = async ({ customerReportId, rating }) => {
  const response = await fetchWrapper(
    hcUrl(`/grace/customer_reports/${customerReportId}/surveys`),
    buildOpts({
      method: 'POST',
      body: formatBody({ customerReportId, rating }),
    })
  );
  return handleResponse(response);
};

export const getGraceSummary = async () => {
  const response = await fetchWrapper(
    hcUrl('/grace/summary'),
    buildOpts({
      method: 'GET',
    })
  );
  return handleResponse(response);
};

export const getAdaToken = async () => {
  const response = await fetchWrapper(
    hcUrl('/chatbot/token'),
    buildOpts({
      method: 'GET',
    })
  );
  return handleResponse(response);
};
